import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//New survey img
import new_photo_button from '../../Images/Photo/Photo.png';

import Camera from './Camera.js';

class CameraPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            displayCameraPopup: false
        };

    }

    togglePopup = () => {
        this.setState(
            { displayCameraPopup: !this.state.displayCameraPopup }
        )
    }

    //Display render
    render(){
        return (
            <div style={{ flex:1, flexDirection:'column', alignItems:'center', justifyContent:'center', paddingTop:"30%"}}>
                {this.props.accountInformation.readOnly === true ?
                    null
                    :
                    <button onClick={this.togglePopup} style={{backgroundColor:"transparent"}}>
                        <img src={new_photo_button} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "35px"}} alt="new_survey_logo"/>
                    </button>
                }
                    {this.state.displayCameraPopup ?
                        <Camera
                            id_patient={this.props.id_patient}
                            cancelPopup={this.togglePopup}
                            update={this.props.update}
                            screenSize={this.props.screenSize}
                        accountInformation={this.props.accountInformation}
                        />
                        :
                        null
                    }
            </div>
        );
    }
}
export default (CameraPopup);